import Slider from "../../../../../../../library/slider";
import { getIcon } from "../../../../../../../utils/get-icon";
import { useSettings } from "../../../context";

import { ResetButton, SliderWrapper } from "./styled";
import { AvailableFilter } from "../../../../types";

type FilterControlProps = {
  config: AvailableFilter;
  currentValue: number;
};

const FilterControl = ({ config, currentValue }: FilterControlProps) => {
  const { setFilterValue } = useSettings();

  const handleValueChange = (newValue: number) => {
    setFilterValue(config.value, newValue);
  };

  const handleSliderChange = (value: number | number[]) => {
    const numericValue = Array.isArray(value) ? value[0] : value;
    if (!isNaN(numericValue)) {
      handleValueChange(numericValue);
    }
  };

  const clickReset = () => {
    handleValueChange(config.defaultValue);
  };

  return (
    <SliderWrapper>
      <Slider
        min={config.min}
        max={config.max}
        step={1}
        value={Number(currentValue)}
        onChange={handleSliderChange}
        dots={false}
      />
      <ResetButton onClick={clickReset}>{getIcon("reset")}</ResetButton>
    </SliderWrapper>
  );
};

export default FilterControl;
